import { margins } from '@olist/styled-system';
import styled, { css } from 'styled-components';
import { focusContainer } from '../../utils/focusContainer.js';
import '../../utils/opacityDisabled.js';
import '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const Wrapper = styled.nav(({ theme }) => css `
    display: flex;
    align-items: center;

    gap: ${theme.olist.spacing.inline.small};
    ${margins}
  `);
const PaginationList = styled.ul `
  list-style: none;
  display: flex;
  margin-left: auto;
`;
const PaginationButton = styled.button(({ selected, notInteractive, theme: { olist: { components: { pagination }, opacity, }, }, }) => css `
    width: ${pagination.button.size};
    height: ${pagination.button.size};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    color: ${pagination.button.color.rest};
    background-color: ${pagination.button['background-color'].rest};
    border: none;

    outline: none;

    &:hover,
    &:focus {
      background-color: ${pagination.button['background-color'].hover};
    }

    ${focusContainer({ inset: true }) ``}

    &:active {
      background-color: ${pagination.button['background-color'].active};
    }

    ${selected &&
    css `
      background-color: ${pagination.button['background-color'].selected};

      ${ParagraphMd} {
        color: ${pagination.button['color'].selected};
      }
    `}

    &:disabled {
      background-color: ${pagination.button['background-color'].disabled};
      opacity: ${opacity.base};
      cursor: not-allowed;
    }

    ${notInteractive &&
    css `
      pointer-events: none;
    `}
  `);
const PaginationListItem = styled.li(({ theme: { olist: { breakpoints, components: { pagination }, }, }, }) => css `
    display: none;

    border-top: 1px solid ${pagination.button['border-color']};
    border-right: 1px solid ${pagination.button['border-color']};
    border-bottom: 1px solid ${pagination.button['border-color']};

    &:first-child {
      display: block;
      border-left: 1px solid ${pagination.button['border-color']};

      &,
      ${PaginationButton} {
        border-top-left-radius: ${pagination.button['border-radius']};
        border-bottom-left-radius: ${pagination.button['border-radius']};
      }
    }

    &:last-child {
      display: block;

      &,
      ${PaginationButton} {
        border-top-right-radius: ${pagination.button['border-radius']};
        border-bottom-right-radius: ${pagination.button['border-radius']};
      }
    }

    @media (min-width: ${breakpoints.small}) {
      display: block;
    }
  `);
const DropdownWrapper = styled.div(({ theme }) => css `
    display: none;

    @media (min-width: ${theme.olist.breakpoints.small}) {
      display: block;
    }
  `);

export { DropdownWrapper, PaginationButton, PaginationList, PaginationListItem, Wrapper };
